import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { FileDeleteDialog } from '../../../../dialogs/FileDeleteDialog/FileDeleteDialog'
import { FileMoveDialog } from '../../../../dialogs/FileMoveDialog/FileMoveDialog'
import { FileRenameDialog } from '../../../../dialogs/FileRenameDialog/FileRenameDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'

export const FileItemMenu = ({ file, idEntity, isFolder = false }) => {
    const { pathname } = useLocation()
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [openRemoveDialog, setOpenRemoveDialog] = React.useState<boolean>(false)
    const [openMoveDialog, setOpenMoveDialog] = React.useState<boolean>(false)
    const [openRenameDialog, setOpenRenameDialog] = React.useState<boolean>(false)

    const open = Boolean(anchorEl)
    const { setIdActiveEditRecord } = useAssistantAdministrationStore((state) => state)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIdActiveEditRecord(undefined)
        setOpenRemoveDialog(false)
        setOpenMoveDialog(false)
        setOpenRenameDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenRemoveDialog = () => {
        setOpenRemoveDialog(true)
    }

    const handleClickOpenMoveDialog = () => {
        setOpenMoveDialog(true)
    }

    const handleClickOpenRenameDialog = () => {
        setOpenRenameDialog(true)
    }

    return (
        <>
            <IconButton
                sx={{
                    p: '4px',
                    '&:hover': { borderColor: '#F4F4F6' },
                }}
                variant="text"
                color="primary"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem onClick={handleClickOpenRenameDialog}>
                    <ListItemText primary={<Typography variant="body">Переименовать</Typography>} />
                    <CreateOutlinedIcon fontSize="small" />
                </MenuItem>
                {pathname.split('/')[1] === 'disk' && (
                    <MenuItem onClick={handleClickOpenMoveDialog}>
                        <ListItemText
                            primary={<Typography variant="body">Переместить в папку</Typography>}
                        />
                        <DriveFileMoveOutlinedIcon fontSize="small" />
                    </MenuItem>
                )}

                <MenuItem onClick={handleClickOpenRemoveDialog}>
                    <ListItemText
                        primary={
                            <Typography variant="body" style={{ color: '#CA1616' }}>
                                Удалить
                            </Typography>
                        }
                    />
                    <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                </MenuItem>
            </Menu>

            {openRemoveDialog && (
                <FileDeleteDialog
                    file={file}
                    idEntity={idEntity}
                    open={openRemoveDialog}
                    handleClose={handleClose}
                    filename={file.filename}
                />
            )}

            {openMoveDialog && (
                <FileMoveDialog file={file} open={openMoveDialog} handleClose={handleClose} />
            )}
            {openRenameDialog && (
                <FileRenameDialog
                    file={file}
                    open={openRenameDialog}
                    handleClose={handleClose}
                    idEntity={idEntity}
                />
            )}
        </>
    )
}
